import { Navigate, Route, Routes } from 'react-router-dom';
import { getSurfaceRouteElement } from '#surface-entry';
import { AuthProvider } from './AuthContext';
import AdminLayout from './components/AdminLayout';
import DashboardPage from './pages/DashboardPage';
import LoginPage from './pages/LoginPage';
import type { AdminSurfaceConfig } from './surface';

interface AdminAppProps {
  surfaceConfig: AdminSurfaceConfig;
}

export default function AdminApp({ surfaceConfig }: AdminAppProps) {
  return (
    <AuthProvider surfaceConfig={surfaceConfig}>
      <Routes>
        <Route path="/login" element={<LoginPage surfaceConfig={surfaceConfig} />} />
        <Route element={<AdminLayout surfaceConfig={surfaceConfig} />}>
          <Route index element={<DashboardPage surfaceConfig={surfaceConfig} />} />
          <Route path="/dashboard" element={<DashboardPage surfaceConfig={surfaceConfig} />} />
          {surfaceConfig.navItems
            .filter((item) => item.path !== '/')
            .map((item) => (
              <Route
                key={item.path}
                path={`${item.path.replace(/^\//, '')}/*`}
                element={getSurfaceRouteElement(item, surfaceConfig)}
              />
            ))}
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
